import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import SectionCard from "./SectionCard";

const Step3AddressInfo = ({
  formData,
  setFormData,
  onFieldChange,
  setFieldValue,
  disable,
  fileArray,
  handleAddFile,
  handleRemoveFile,
}) => {
  const handleYesNoChange = (name, value) => {
    onFieldChange({ target: { name, value } });
  };
  const handleDocAttachment = (docKey, file) => {
    if (setFieldValue) setFieldValue(`${docKey}_attachment`, file);
    else if (setFormData)
      setFormData((prev) => ({ ...prev, [`${docKey}_attachment`]: file }));
  };
  const handleRemoveDocAttachment = (docKey) => {
    if (setFieldValue) setFieldValue(`${docKey}_attachment`, null);
    else if (setFormData)
      setFormData((prev) => ({ ...prev, [`${docKey}_attachment`]: null }));
  };

  const fieldsEnabledQC = Boolean(disable?.isQCTeam || disable?.isAdmin);
  const fieldsEnabledHR = Boolean(disable?.isHRTeam || disable?.isAdmin);
  const fieldsEnabledFinance = Boolean(
    disable?.isFinanceTeam || disable?.isAdmin,
  );

  const docList = [
    { key: "rentedBuilding", label: "If rented building (rental copy)" },
    { key: "ownBuildingOwnership", label: "If Own building ownership details" },
    {
      key: "companyRegistrationCertificate",
      label: "Company registration certificate",
    },
    { key: "factoryLicence", label: "Factory Licence" },
    { key: "fireCertificate", label: "Fire Certificate" },
    {
      key: "epfCodeRegistration",
      label: "Establishment EPF code registration",
    },
    {
      key: "esiCodeRegistration",
      label: "Establishment ESI code registration",
    },
    { key: "panCard", label: "PAN card (company / Owner) copy" },
    {
      key: "aadharCard",
      label: "Udyog Aadhar Card or Owners Aadhar card copy",
    },
    { key: "factoryBankDetails", label: "Factory Bank details" },
    { key: "listOfMachinery", label: "List of Machinery" },
    {
      key: "polutionCentrolBoard",
      label: "Pollution Control board Certificate (Printing and Dying))",
    },
  ];

  const getAttachment = (docKey) => {
    return fileArray?.find((f) => f.docKey === docKey)?.file;
  };

  return (
    <Grid container spacing={2}>
      <SectionCard title="Evaluation done by">
        <Grid container spacing={2}>
          {[
            { key: "qualityTeam", label: "Quality Team", group: "QC" },
            { key: "hrTeam", label: "HR Team", group: "HR" },
            { key: "financeTeam", label: "Finance Team", group: "Finance" },
          ].map((team) => {
            const isDisabled =
              (team.group === "QC" && !fieldsEnabledQC) ||
              (team.group === "HR" && !fieldsEnabledHR) ||
              (team.group === "Finance" && !fieldsEnabledFinance);
            return (
              <Grid item xs={12} sm={4} key={team.key}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  {team.label}
                </Typography>
                <TextField
                  disabled={isDisabled}
                  fullWidth
                  label="Name"
                  name={`${team.key}Name`}
                  value={formData[`${team.key}Name`] || ""}
                  onChange={onFieldChange}
                  size="small"
                  sx={{ mb: 1 }}
                />
                <TextField
                  disabled={isDisabled}
                  fullWidth
                  label="Signature"
                  name={`${team.key}Signature`}
                  value={formData[`${team.key}Signature`] || ""}
                  onChange={onFieldChange}
                  size="small"
                />
              </Grid>
            );
          })}
        </Grid>
      </SectionCard>

      <SectionCard title="Approved as Supplier by:">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Head Manufacturing / CSO: Name"
              name="headManufacturing"
              value={formData.headManufacturing || ""}
              onChange={onFieldChange}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Signature"
              name="headManufacturingSignature"
              value={formData.headManufacturingSignature || ""}
              onChange={onFieldChange}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Dated"
              name="approvedDate"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formData.approvedDate || ""}
              onChange={onFieldChange}
              size="small"
            />
          </Grid>
        </Grid>
      </SectionCard>

      <SectionCard title="List of documents to be collected:">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>SI No</TableCell>
                    <TableCell>Documents check list</TableCell>
                    <TableCell>Yes / No</TableCell>
                    <TableCell>Remarks</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {docList.map((doc, idx) => {
                    const isYes = formData[`${doc.key}`] === "Y";
                    // const attachment = formData[`${doc.key}_attachment`];
                    const attachment = getAttachment(doc.key);
                    return (
                      <TableRow key={doc.key}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{doc.label}</TableCell>
                        <TableCell>
                          <RadioGroup
                            row
                            name={`${doc.key}`}
                            value={formData[`${doc.key}`] || ""}
                            onChange={(e) => {
                              handleYesNoChange(`${doc.key}`, e.target.value);
                              if (e.target.value === "N")
                                handleRemoveDocAttachment(doc.key);
                            }}
                          >
                            <FormControlLabel
                              disabled={!fieldsEnabledHR}
                              value="Y"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              disabled={!fieldsEnabledHR}
                              value="N"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </TableCell>
                        <TableCell>
                          <TextField
                            disabled={!fieldsEnabledHR}
                            fullWidth
                            size="small"
                            name={`${doc.key}Remarks`}
                            value={formData[`${doc.key}Remarks`] || ""}
                            onChange={onFieldChange}
                          />
                        </TableCell>
                        <TableCell>
                          {isYes ? (
                            <Box>
                              <input
                                type="file"
                                accept=".pdf,.doc,.docx,image/*"
                                disabled={!fieldsEnabledHR}
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  //if (file) handleDocAttachment(doc.key, file);
                                  if (file) {
                                    handleAddFile(doc.key, file);
                                  }
                                  e.target.value = "";
                                }}
                                style={{ fontSize: "12px", marginBottom: 4 }}
                              />
                              {attachment && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <Chip
                                    size="small"
                                    label={attachment.name || "File"}
                                    onDelete={() => handleRemoveFile(doc.key)}
                                    //onDelete={() => handleRemoveDocAttachment(doc.key)} variant="outlined"
                                  />
                                </Box>
                              )}
                            </Box>
                          ) : (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            ></Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </SectionCard>
    </Grid>
  );
};

export default Step3AddressInfo;
